import { render, staticRenderFns } from "./ModalAccountsReceivable.vue?vue&type=template&id=5108a60e"
import script from "./ModalAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./ModalAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountsReceivable.vue?vue&type=style&index=0&id=5108a60e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports